import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import { useStore } from 'effector-react';
import $auth, { loginFx } from './store';

export default function AuthController({ children }) {
    const authStore = useStore($auth);

    useEffect(() => {
        loginFx();
    }, []);

    if (authStore.isLogin) {
        return <>{children}</>;
    }

    return (
        <>
            {<Typography>{authStore.message}</Typography>}
        </>
    );
}
